import { AmountDetails } from '@cart-ui/AmountDetails/AmountDetails'
import { Box } from '@pets-ui/Box/Box'
import { Container } from '@pets-ui/Container/Container'
import { type MobileMediaQuery } from '@pets-ui/tokens/breakpoints.stylex'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { I18nextProvider } from 'react-i18next'
import orderDetailInstance from '../../../i18n/i18nConfig'
import { AllOrdersFastpass } from '../../fastpass/AllOrdersFastpass'
import { AllOrdersOfficialWebsite } from '../../official-website/AllOrdersOfficialWebsite'
import { useContextOrderDetail } from '../OrderDetailProvider/OrderDetailProvider'
import { OrderPaymentInfo } from './OrderPaymentInfo'
import { OrderSummary } from './OrderSummary'
const MOBILE: MobileMediaQuery = '@media (max-width: 480px)'

const styles = stylex.create({
  root: {
    minHeight: '100vh',
    width: '100%',
  },
})

const orderAmountStyles = stylex.create({
  layout: {
    direction: 'rtl',
    display: {
      [MOBILE]: 'block',
      default: 'grid',
    },
    gridTemplateColumns: '1fr 1fr',
  },
  info: {
    padding: 12,
    borderRadius: 8,
    gap: 12,
    backgroundColor: colors.white,
    direction: 'ltr',
  },
})

interface OrderDetailProps {
  isOfficialWebsite?: boolean
}
export function OrderDetail({ isOfficialWebsite = false }: OrderDetailProps) {
  const { transaction, currency } = useContextOrderDetail()
  const { created_at: createdAt, child_orders, status, refund_status: refundStatus } = transaction || {}
  const {
    discount_items,
    subtotal,
    discount_total: discountTotal,
    shipping_total: shippingTotal,
    total,
    payment_info,
    payment_method: paymentMethod,
    need_pdf: needOrderPdf,
    posting_date_in_next_month: postingDateInNextMonth,
    reward_point_discount,
    referral_code_discount,
    country_code: countryCode,
    tax,
    addon_v2_total,
    addon_v2_total_before_discount,
  } = transaction || {}

  return (
    <I18nextProvider i18n={orderDetailInstance}>
      <Box rootStyle={styles.root}>
        <Container maxWidth={960}>
          <VStack gap={4}>
            <OrderSummary
              transactionId={transaction?.transaction_id}
              orderCreatedTime={createdAt}
              orders={child_orders}
              status={status}
              paymentMethod={paymentMethod?.type}
              refundStatus={refundStatus}
            />
            {isOfficialWebsite
              ? <AllOrdersOfficialWebsite orders={child_orders ?? []} />
              : <AllOrdersFastpass orders={child_orders} />}
            <Box rootStyle={orderAmountStyles.layout}>
              <AmountDetails
                discountItems={discount_items}
                subtotal={subtotal}
                discountTotal={discountTotal}
                shippingTotal={shippingTotal}
                total={total}
                currency={currency}
                rootStyle={orderAmountStyles.info}
                reward_point_discount={reward_point_discount}
                referral_code_discount={referral_code_discount}
                countryCode={countryCode}
                tax={tax}
                addonV2Total={addon_v2_total}
                addonV2TotalBeforeDiscount={addon_v2_total_before_discount}
              />
            </Box>
            <Box rootStyle={orderAmountStyles.layout}>
              <OrderPaymentInfo
                paymentMethod={paymentMethod?.type}
                needPdf={needOrderPdf}
                postingDateInNextMonth={postingDateInNextMonth}
                paymentInfo={payment_info}
                rootStyle={orderAmountStyles.info}
              />
            </Box>
          </VStack>
        </Container>
      </Box>
    </I18nextProvider>
  )
}
